import type { ModalMapType } from "../../../../../../common-deprecated/types/CommonTypes";
import { aemLexusCommonModalMap } from "../../../../../../common-deprecated/components/modals/aem/lexus/modals";
import type { BnBModalIdsType } from "../../../utils/modalConstants";
import {
    MODAL_ALTERNATIVES_ETA,
    MODAL_BUY_TERMS,
    MODAL_CONFIG_CODE,
    MODAL_ENGINE_DETAIL,
    MODAL_EXIT_PASSIVE_SUMMARY,
    MODAL_EXTRA_CONFLICT,
    MODAL_EXTRA_ONLY_PACK_MULTIPLE,
    MODAL_EXTRA_ONLY_PACK_SINGLE,
    MODAL_FINANCE_CALCULATOR,
    MODAL_FINANCE_INFO,
    MODAL_FINANCE_TOGGLE,
    MODAL_LEASE_TERMS,
    MODAL_MASS_MANAGEMENT,
    MODAL_PACK_CONFLICT,
    MODAL_RESERVE_TERMS,
    MODAL_WINTER_WHEELS,
} from "../../../utils/modalConstants";
import EngineDetailsModal from "../../common/modals/EngineDetailsModal";
import FinanceCalculatorModal from "./FinanceCalculatorModal";
import ConfigCodeModal from "./ConfigCodeModal";
import FinanceModal from "../../common/FinanceModal"; // debug modal, so no need to have a separate view
import BuyTermsModal from "../../common/modals/BuyTermsModal";
import WinterWheelsModal from "./WinterWheelsModal";
import AlternativesETAModal from "./AlternativesETAModal";
import PackConflictModal from "./PackConflictModal";
import ExtraConflictModal from "./ExtraConflictModal";
import ExitPassiveSummaryModal from "../../common/modals/ExitPassiveSummaryModal";
import MassManagementModal from "./MassManagementModal";
import ReserveTermsModal from "./ReserveTermsModal";
import { MODAL_INTEGRATED_TRADE_IN_AEM } from "../../../../../../shared-logic/features/tradein/utils/integratedModalConstants";
import FinanceToggleModal from "./FinanceToggleModal";
import IntegratedTradeInAemModal from "./tradein/IntegratedTradeInAemModal";
import DetailedTyreInfoModal from "./tyreInfoModal/DetailedTyreInfoModal";
import LeaseTermsModal from "./LeaseTermsModal";
import ExtraOnlyPackSingleModal from "./ExtraOnlyPackSingleModal";
import ExtraOnlyPackMultipleModal from "./ExtraOnlyPackMultipleModal";
import { MODAL_DETAILED_TYRE_INFO } from "../../../../../../shared-logic/utils/tyreInfoContants";

export const aemLexusBnbModalMap: ModalMapType<BnBModalIdsType> = {
    ...aemLexusCommonModalMap,
    [MODAL_ENGINE_DETAIL]: EngineDetailsModal,
    [MODAL_FINANCE_INFO]: FinanceModal,
    [MODAL_FINANCE_CALCULATOR]: FinanceCalculatorModal,
    [MODAL_CONFIG_CODE]: ConfigCodeModal,
    [MODAL_BUY_TERMS]: BuyTermsModal,
    [MODAL_RESERVE_TERMS]: ReserveTermsModal,
    [MODAL_LEASE_TERMS]: LeaseTermsModal,
    [MODAL_WINTER_WHEELS]: WinterWheelsModal,
    [MODAL_ALTERNATIVES_ETA]: AlternativesETAModal,
    [MODAL_PACK_CONFLICT]: PackConflictModal,
    [MODAL_EXTRA_CONFLICT]: ExtraConflictModal,
    [MODAL_EXIT_PASSIVE_SUMMARY]: ExitPassiveSummaryModal,
    [MODAL_FINANCE_TOGGLE]: FinanceToggleModal,
    [MODAL_MASS_MANAGEMENT]: MassManagementModal,
    [MODAL_DETAILED_TYRE_INFO]: DetailedTyreInfoModal,
    [MODAL_INTEGRATED_TRADE_IN_AEM]: IntegratedTradeInAemModal,
    [MODAL_EXTRA_ONLY_PACK_SINGLE]: ExtraOnlyPackSingleModal,
    [MODAL_EXTRA_ONLY_PACK_MULTIPLE]: ExtraOnlyPackMultipleModal,
};
